export default __webpack_public_path__ + "static/media/b1.5c5df4e3.png";